import React from "react";
import technicolor from "../assets/technicolor.webp";
import Greengold from "../assets/Greengold.webp";
import mpcfilm from "../assets/mpc-film.webp";
import dq from "../assets/DQ-Entertainment.webp";
import amazon from "../assets/amazon.webp";
import sen from "../assets/Sen.webp";
import Decornt from "../assets/Decornt.webp";
import Wayhighs from "../assets/Wayhighs.webp";
import ctrl from "../assets/ctrl.webp";

const logos = [
  { src: technicolor, alt: "Technicolor" },
  { src: Greengold, alt: "Green Gold" },
  { src: mpcfilm, alt: "MPC Film" },
  { src: dq, alt: "DQ Entertainment" },
  { src: amazon, alt: "Amazon" },
  { src: sen, alt: "Sen" },
  { src: Decornt, alt: "Decornt" },
  { src: Wayhighs, alt: "Wayhighs" },
  { src: ctrl, alt: "ctrl" },
];

const Placements = () => {
  return (
    <section
      id="placements"
      className="w-full bg-[#090522] text-white overflow-hidden"
    >
      <h2 className="text-3xl text-yellow-400 font-bold text-center mb-4">
        <span className="text-orange-500">P</span>LACEMENTS
      </h2>

      {/* Scrolling marquee on mobile only */}
      <div className="block md:hidden w-full py-4 overflow-hidden relative">
        <div className="flex animate-marqueePlace whitespace-nowrap">
          {[...logos, ...logos].map((logo, index) => (
            <div key={index} className="flex-shrink-0 px-4">
              <img
                src={logo.src}
                alt={logo.alt}
                className="h-10 object-contain"
              />
            </div>
          ))}
        </div>
      </div>

      {/* Static logos on md+ screens */}
      <div className="hidden md:flex flex-wrap justify-center gap-6 md:gap-8 lg:gap-12 py-4">
        {logos.map((logo, index) => (
          <img
            key={index}
            src={logo.src}
            alt={logo.alt}
            className="h-10 md:h-14 lg:h-20 object-contain"
          />
        ))}
      </div>
    </section>
  );
};

export default Placements;
